<template>
  <Header class="header">
    <div class="navbar-header">
      <div class="h-logo-box">
        <img src="../../../static/images/logo2.png" alt class="logo" />
        <h2 class="company-name">蓝茨盆底肌训练仪-后台管理系统</h2>
      </div>
      <iframe width="300" height="20" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&id=10&icon=1&site=12"></iframe>
      <div class="personal-imformation">
        <div class="account">
          {{user.type == 1?"超级管理员":"普通管理员"}}
          <br />
          {{user.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{user.phone}}
        </div>
        <el-dropdown @command="openDropdownMenu">
          <el-button type="text">
            <img src="../../../static/images/setting.png" class="setting" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="updatePassword">操作密码</el-dropdown-item> -->
            <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 修改密码 -->
    <el-dialog title="修改操作密码" :visible.sync="updatePasswordDialogVisible" width="540px" :close-on-click-modal="false">
      <div class="dialog_context">
        <el-form :model="form" :rules="rules" ref="updatePasswordForm">
          <el-form-item label="手机号" :label-width="formLabelWidth">
            {{user.phone}}
          </el-form-item>
          <el-form-item label="验证码" :label-width="formLabelWidth" prop="code">
            <el-input type="number" maxlength="6" v-model="form.code" autocomplete="off">
               <template slot="append">
                 <div style="width:80px;text-align:center;">
                  <el-button v-if="codeTime == 0" :disabled="codeTime > 0" @click="getCode()">
                    <span class="get_code">获取验证码</span>
                  </el-button>
                  <span v-if="codeTime > 0">
                    <!-- {{codeTime == 0?"获取验证码":"重新发送("+codeTime+")"}} -->
                    重新发送({{codeTime}})
                  </span>
                  </div>
               </template>
            </el-input>
            
          </el-form-item>
          <el-form-item label="操作密码" :label-width="formLabelWidth" prop="password">
            <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updatePasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdatePassowrd('updatePasswordForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 退出登录弹框 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="18%" center>
      <div style="font-size:16px;width:100%;text-align:center;">确定要退出登录吗?</div>
      <span slot="footer" class="dialog-footer" :center="false">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmLoginOut">确 定</el-button>
      </span>
    </el-dialog>
  </Header>
</template>
<script>
export default {
  data() {

    return {
      user: null,
      dialogFormVisible: false,
      showModifyTips: false,
      dialogVisible: false,
      formLabelWidth: "80px",
      // 显示修改密码对话框
      updatePasswordDialogVisible: false,
      // 修改密码数据
      form: {
        code: null,
        password: null
      },
      codeTime: 0,
      rules: {
        code: [
          { required: true, message: "请输验证码", trigger: "blur" },
          { min: 6, max: 6, message: "验证码长度为 6 位", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入操作密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为 6 至 20 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));

    // if(this.user.operationPwd == '0'){
    //   this.$confirm('检测到您还没有设置操作密码，是否立即设置?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       this.updatePasswordDialogVisible = true;
    //     }).catch(() => {
           
    //     });
    // }

  },
  methods: {
    openDropdownMenu(res) {
      console.log("666666", res);
      if ("loginOut" === res) {
        this.dialogVisible = true;
      } else {
        this.updatePasswordDialogVisible = true;
      }
    },
    getCode(){
      
      let that = this;

      this.$axios
          .post("/web/other/getCode")
          .then(res => {
            console.log(res.data);
            if (res.data.code == 1000) {
              that.$message.success("验证码发送成功！");
              this.codeTime = 60;
              let intervalCodeTime = setInterval(function(){
                that.codeTime = that.codeTime - 1;
                console.log("倒计时："+that.codeTime)
                if(that.codeTime <= 0){
                  console.log("结束")
                  clearInterval(intervalCodeTime);
                }
              },1000)
            } else if(res.data.code == 2001){
              that.$message.error("登录失效，请重新登录");
              that.$router.push({ path: "/login" });
            } else{
              this.$message.error(res.data.message);
            }
            this.dialogFormVisible = false;
          })
          .catch(err => {
            console.log(err);
          });

      
    },
    submitUpdatePassowrd(ref) {
      this.$refs[ref].validate(valid => {
        // 校验结果
        if (!valid) {
          // 校验不通过
          return;
        }
        const url = "/web/login/updateOperationPwdByCode";
        this.$axios
          .post(url, {
            password: this.form.password,
            code: this.form.code
          })
          .then(res => {
            console.log(res.data);
            if (res.data.code == 1000) {
              this.$message({
                message: "密码修改成功",
                type: "success"
              });
              this.updatePasswordDialogVisible = false;
            } else if(res.data.code == 2001){
              that.$message.error("登录失效，请重新登录");
              that.$router.push({ path: "/login" });
            } else {
              this.$message.error(res.data.message);
            }
            this.dialogFormVisible = false;
          })
          .catch(err => {
            console.log(err);
          });
      })
    },
    confirmLoginOut() {
      //点击退出登录按钮

      sessionStorage.clear();

      this.dialogVisible = false;
      setTimeout(() => {
        this.$router.push({ path: "/login" });
      }, 500);
    }
  }
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 94px;
  /* background: #21413a; */
  background: #00cb9f;
  /*background: #63DEFF;*/
}
.navbar-header {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
}
.h-logo-box,
.personal-imformation {
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.logo {
  width: 80px;
  margin-left: 5px;
  margin-right: 16px;
}
.company-name {
  font-family: HiraMaruPro-W4;
  font-size: 35px;
  color: #ffffff;
  letter-spacing: 1px;
  line-height: 60px;
}

.setting {
  margin-right: 20px;
}
.account {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  letter-spacing: 0;
  margin-right: 30px;
  text-align: right;
  line-height: 20px;
  color: #fafafa;
}
/* 修改密码框 */
.dialog_context {
  width: 480px;
}
.get_code{
  color: #409eff;
}
.get_code:hover{
  color: #85e4cf
}
</style>


// WEBPACK FOOTER //
// src/components/pages/navbar.vue